import HttpClient from "../base/http-client";

export default class FileClient extends HttpClient {
    constructor() {
        super("files");
    }
}
